import { render, staticRenderFns } from "./DetailWidgets.vue?vue&type=template&id=724bc342&scoped=true&"
import script from "./DetailWidgets.vue?vue&type=script&lang=js&"
export * from "./DetailWidgets.vue?vue&type=script&lang=js&"
import style0 from "./DetailWidgets.vue?vue&type=style&index=0&id=724bc342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724bc342",
  null
  
)

export default component.exports